import React from 'react'
import { FaGithub } from "react-icons/fa";
import { BiMoviePlay } from "react-icons/bi";
import { HiOutlineDesktopComputer } from "react-icons/hi";
import { FaFigma } from "react-icons/fa6";

const icons = {
	"Code": <FaGithub className="text-lg" />,
	"Visit": <HiOutlineDesktopComputer className="text-lg" />,
	"Video Demo": <BiMoviePlay className="text-lg" />,
	"Design": <FaFigma className="text-lg" />
};

const CustomButton = ({ theme, text, onHandle }) => {
	return (
		<div className="custom_btn_wrapper tracking-wide" style={{ "--theme-color": theme }}>
			<button className="custom_btn" onClick={onHandle}>
				{icons[text]} {text}
			</button>
			<div className='custom_btn_shadow'></div>
		</div>
	)
}

export default CustomButton